import React, { Fragment, useRef } from 'react';
import { useInitialRender } from '../../../../play-core/hooks/use-initial-render';
import { useMeasure } from '../../../../play-core/hooks/use-measure';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MessageIfEmpty = ({
  children,
  messageComponent,
  isLoading = false
}) => {
  const containerRef = useRef(null);
  const {
    height
  } = useMeasure(containerRef);
  const isInitialRender = useInitialRender();
  const showError = !isLoading && height <= 0 && !isInitialRender;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      ref: containerRef,
      children: children
    }), showError && messageComponent]
  });
};